export default __webpack_public_path__ + "static/media/icon_linkedin.7892a7a4.svg";